import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import {Card as RmwcCard} from '@rmwc/card'
import '@rmwc/card/styles'

const StyledRmwcCard = styled(RmwcCard)`
  &&& {
    border-radius: 0.8rem;
  }
`

const Card = ({children, ...otherProps}) => <StyledRmwcCard {...otherProps}>{children}</StyledRmwcCard>

Card.propTypes = {
  children: PropTypes.any
}

export {Card}
